import { DataTable, useColumns } from "@/components/data-table";
import { useFilters } from "@/components/filters";
import { ListPage } from "@/components/list-page";
import { Dialog, ModalHeader, ModalValueExtractor, useOpenModal } from "@/components/modal";
import { useGetAllRegistroAuditoriasQuery } from "@/features/administracion/auditoria/api/get-all-registro-auditorias";
import RegistroAuditoriaView from "@/features/administracion/auditoria/components/registro-auditoria-view";
import { renderClavePrimaria, renderColumnasAfectadas, renderTipoAccion } from "@/features/administracion/auditoria/shared/utils";
import { formatDate, formatString } from "@/shared/formats";
import { TipoAuditoria } from "@/shared/types/registro-auditoria";

export default function RegistroAuditoriasPage() {
    const openModal = useOpenModal();

    const filterData = useFilters({
        filters: [
            { type: "dateRange", fromName: "desde", toName: "hasta", label: "Fecha" },
            {
                type: "select", name: "tipoAuditoria", label: "Tipo de Auditoría", options: [
                    { value: "", label: <i>Ninguno</i> },
                    { value: TipoAuditoria.Added, label: "Adición" },
                    { value: TipoAuditoria.Modified, label: "Modificación" },
                    { value: TipoAuditoria.Deleted, label: "Eliminación" }
                ]
            },
            { type: "string", name: "nombreUsuario", label: "Usuario" },
            { type: "string", name: "nombreTabla", label: "Tabla" },
            { type: "string", name: "columnasAfectadas", label: "Columna Afectadas" },
            { type: "string", name: "clavePrimaria", label: "Clave Primaria" },
            { type: "pagination" }
        ]
    });

    const fetchData = useGetAllRegistroAuditoriasQuery(filterData.filterData);

    const columnData = useColumns({
        key: "auditoria",
        columns: [
            { key: "fecha", header: "Fecha", render: (row) => formatDate(row.fecha, true), width: "auto" },
            { key: "nombreTabla", header: "Tabla", render: (row) => formatString(row.nombreTabla) },
            { key: "nombreUsuario", header: "Usuario", render: (row) => formatString(row.nombreUsuario) },
            { key: "tipoAuditoria", header: "Tipo de Acción", render: (row) => renderTipoAccion(row.tipoAuditoria), align: "center" },
            { key: "clavePrimaria", header: "ID Afectado", render: (row) => renderClavePrimaria(row.clavePrimaria), show: false },
            { key: "columnasAfectadas", header: "Columnas Afectadas", render: (row) => renderColumnasAfectadas(row.columnasAfectadas), show: false }
        ]
    });

    return <ListPage>
        <ListPage.Header>
            <ListPage.Header.Actions title="Registros de Auditoría">
                <ListPage.Header.Actions.FilterButton />
                <ListPage.Header.Actions.ColumnButton columnData={columnData} />
            </ListPage.Header.Actions>
            <ListPage.Header.Filters filterData={filterData} />
        </ListPage.Header>
        <DataTable flex={1}>
            <DataTable.Content
                rows={fetchData.data?.result}
                columns={[
                    ...columnData.columns,
                    {
                        header: "Acción", width: "auto", align:"center", render: row => <DataTable.EntryOption>
                            <DataTable.EntryOption.ViewButton onClick={() => openModal("view", row)} />
                        </DataTable.EntryOption>
                    }
                ]}
                fit="flex"
                loading={fetchData.isFetching}
                error={fetchData.error}
            />
            <DataTable.Pagination filterData={filterData} queryResult={fetchData} />
        </DataTable>

        <Dialog code="view" size="sm">
            <ModalValueExtractor>
                {registro => <>
                    <ModalHeader>Registro {formatDate(registro.fecha)}</ModalHeader>
                    <RegistroAuditoriaView registro={registro} />
                </>}
            </ModalValueExtractor>
        </Dialog>
    </ListPage>
}